
var sprite = require("C:/git/annenberg-petspace-petbook/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 17.74 19.28\" id=\"share\" ><title>Asset 1</title><g data-name=\"Layer 2\"><g data-name=\"Layer 1\"><path d=\"M17 19.28H.75a.75.75 0 0 1-.75-.75v-5.61a.75.75 0 0 1 1.5 0v4.87h14.74v-4.87a.75.75 0 0 1 1.5 0v5.62a.75.75 0 0 1-.74.74z\"/><path d=\"M8.87 14.39a1.16 1.16 0 0 1-1.16-1.16V4.66a1.16 1.16 0 1 1 2.32 0v8.57a1.16 1.16 0 0 1-1.16 1.16z\"/><path d=\"M3.2 6.95L8.54.16a.42.42 0 0 1 .66 0l5.34 6.79a.42.42 0 0 1-.33.68H3.53a.42.42 0 0 1-.33-.68z\"/></g></g></symbol>";
module.exports = sprite.add(image, "share");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/share.svg
// module id = 311
// module chunks = 1